import { ReactiveMap } from "@solid-primitives/map"
import type { EntityGraphNode } from "../../lib/core/engine/EntityGraphNode/EntityGraphNode.type"
import type { EntityTypeId } from "../../lib/core/entity/EntityTypeId.enum"
import type { Entity } from "../../lib/core/entity/index"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export type EntityByEntityTypeIdReactiveMap = ReactiveMap<EntityTypeId, Array<EntityGraphNode>>

export const useEntityByEntityTypeIdReactiveMap = createSharedCachedFactory((
  // engine: Engine
) => {

  const map = new ReactiveMap<EntityTypeId, Array<EntityGraphNode<Entity>>>()

  return map
})